var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',_vm._g({attrs:{"type":_vm.showBtnType.btnType}},_vm.$listeners),[(_vm.showIcon)?_c('a-icon',{attrs:{"type":_vm.showBtnType.iconType}}):_vm._e(),_vm._v(" "+_vm._s(_vm.showBtnType.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }